import React from "react";
import CrudPage, { ActiveBadge } from "@/components/CrudPage";

const TYPES = [
  { value: "machine", label: "Makine Üretimi" },
  { value: "manual", label: "Manuel Üretim" },
  { value: "team", label: "Ekip Bazlı" },
  { value: "mixed", label: "Karma" },
];

const COLUMNS = [
  { key: "code", label: "Kod" },
  { key: "name", label: "Bölüm Adı", render: (d) => (
    <span className="flex items-center gap-2">
      <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: d.color || "#2563EB" }} />
      {d.name}
    </span>
  ) },
  { key: "dept_type", label: "Tip", render: (d) => TYPES.find((t) => t.value === d.dept_type)?.label || d.dept_type },
  { key: "manager", label: "Sorumlu", render: (d) => d.manager || "-" },
  { key: "active", label: "Durum", render: (d) => <ActiveBadge value={d.active} /> },
];

const FIELDS = [
  { name: "code", label: "Bölüm Kodu", required: true, placeholder: "Örn: CNC" },
  { name: "name", label: "Bölüm Adı", required: true },
  { name: "dept_type", label: "Bölüm Tipi", type: "select", options: TYPES },
  { name: "manager", label: "Bölüm Sorumlusu" },
  { name: "color", label: "Renk (hex)", placeholder: "#2563EB" },
  { name: "active", label: "Aktif", type: "checkbox" },
];

export default function Departments() {
  return (
    <CrudPage
      title="Bölümler"
      subtitle="Dinamik bölüm yönetimi — yeni bölüm eklediğinizde tüm modüllere otomatik dahil olur"
      endpoint="departments"
      testidPrefix="departments"
      defaultForm={{ active: true, dept_type: "manual", color: "#2563EB" }}
      columns={COLUMNS}
      fields={FIELDS}
    />
  );
}
